import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-header',
  templateUrl: './auth-header.component.html'
})
export class AuthHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
